import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Spinner} from "@heroui/react";
import ComponentsReports from "../../components/Private/ComponentsReports";
import Header from "../../components/Private/Header";
import Date from "../../components/Private/Date";
import {useQuery} from "@tanstack/react-query";
import {request} from "../../lib/request";
import {DateObject} from "react-multi-date-picker";
import {ReactComponent as CalendarIcon} from "../../assets/icons/calendar.svg";

const TABS = [
    {key: 'all', label: 'همه'},
    {key: 'pike', label: 'پرداخت آنلاین'},
    {key: 'in_person', label: 'پرداخت در محل'},
];

const Reports = () => {
    const [tab, setTab] = useState("all");
    const [from, setFrom] = useState();
    const [to, setTo] = useState();
    const committedReportRef = useRef(null);

    const fromDate = from ? new DateObject(from.toDate()).format("YYYY-MM-DD") : undefined;
    const endDate = to ? new DateObject(to.toDate()).format("YYYY-MM-DD") : undefined;
    const hasDateFilter = Boolean(from || to);

    const {data, isLoading, isFetching} = useQuery({
        queryKey: ["report", "index", tab, fromDate, endDate],
        queryFn: async () => await request({
            url: "/restaurant/report",
            method: "get",
            query: {tab: tab === "all" ? null : tab, from: fromDate, to: endDate},
        }),
    });

    useEffect(() => {
        if (!isFetching && data?.data) {
            committedReportRef.current = data.data;
        }
    }, [data, isFetching]);

    const reportData = !isFetching && data?.data
        ? data.data
        : committedReportRef.current;

    const hasFoods = !!reportData?.foods?.length;
    const showInitialLoading = isLoading && !reportData;
    const showFetchingOverlay = isFetching && !!reportData;

    const periodLabel = useMemo(() => {
        if (fromDate && endDate) {
            return `از ${new DateObject(from).format("YYYY/MM/DD")} تا ${new DateObject(to).format("YYYY/MM/DD")}`;
        }
        if (fromDate) {
            return `از ${new DateObject(from).format("YYYY/MM/DD")}`;
        }
        if (endDate) {
            return `تا ${new DateObject(to).format("YYYY/MM/DD")}`;
        }
        return 'همه روزها';
    }, [from, to, fromDate, endDate]);

    const clearDates = () => {
        setFrom(undefined);
        setTo(undefined);
    };

    return (
        <section className="rest-reports-page">
            <Header title="گزارشات"/>

            <div className="rest-reports-hero">
                <div className="rest-reports-hero__content">
                    <span className="rest-reports-hero__eyebrow">تحلیل فروش</span>
                    <h1 className="rest-reports-hero__title">گزارش عملکرد رستوران</h1>
                    <p className="rest-reports-hero__text">
                        وضعیت سفارش‌ها و پرفروش‌ترین غذاها را در بازه زمانی دلخواه ببینید.
                    </p>
                </div>
                <div className="rest-reports-hero__chip">
                    <CalendarIcon aria-hidden="true"/>
                    <span>{periodLabel}</span>
                </div>
            </div>

            <div className="rest-reports-toolbar">
                <div className="rest-reports-filters">
                    <Date setValue={setFrom} label="از تاریخ"/>
                    <Date setValue={setTo} label="تا تاریخ"/>
                    <button
                        type="button"
                        className={`rest-reports-filters__clear${hasDateFilter ? ' rest-reports-filters__clear--visible' : ''}`}
                        onClick={clearDates}
                        tabIndex={hasDateFilter ? 0 : -1}
                        aria-hidden={!hasDateFilter}
                    >
                        پاک کردن تاریخ
                    </button>
                </div>

                <div className="rest-reports-tabs" role="tablist" aria-label="نوع پرداخت">
                    {TABS.map((item) => (
                        <button
                            key={item.key}
                            type="button"
                            role="tab"
                            aria-selected={tab === item.key}
                            className={`rest-reports-tabs__btn${tab === item.key ? ' rest-reports-tabs__btn--active' : ''}`}
                            onClick={() => setTab(item.key)}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="rest-reports-content">
                {showFetchingOverlay ? (
                    <>
                        <p className="rest-reports-content__refresh">در حال بروزرسانی...</p>
                        <div className="rest-reports-content__overlay" aria-hidden="true">
                            <Spinner color="warning"/>
                        </div>
                    </>
                ) : null}

                {showInitialLoading ? (
                    <div className="rest-orders-state rest-orders-state--loading">
                        <Spinner color="warning"/>
                        <p>در حال بارگذاری گزارش...</p>
                    </div>
                ) : hasFoods ? (
                    <ComponentsReports data={reportData}/>
                ) : (
                    <div className="rest-orders-state rest-orders-state--empty">
                        <img
                            src="/images/Empty page.png"
                            alt=""
                            className="rest-orders-state__image"
                        />
                        <p className="rest-orders-state__title">داده‌ای برای نمایش نیست</p>
                        <p className="rest-orders-state__text">
                            در این بازه زمانی و فیلتر انتخاب‌شده سفارشی ثبت نشده است.
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default Reports;
